import { useState } from 'react';
import { DialogUI } from '../Interface';
import { ItemPage } from './ItemPage';

const ItemDialog = ({ showDialog, onClose }) => {
  const [selectedItem, setSelectedItem] = useState(null);

  const handleClose = () => {
    if (onClose) {
      // ha nincs kiválasztott cikk, null-lal hívjuk vissza
      onClose(selectedItem ?? null);
    }
    // lokális állapot reset a következő nyitáshoz
    setSelectedItem(null);
  };

  return (
    <DialogUI
      open={showDialog}
      headerContent={'Cikkek'}
      fullWidth={true}
      onClose={handleClose}
      closeBtn={true}
      maxWidth="xl"
    >
      <ItemPage fromDialog={true} dialogSetSelectedItem={setSelectedItem} />
    </DialogUI>
  );
};

export default ItemDialog;
